var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomHotWaterHeater({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 171,
    viewBox: "0 0 77 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M60 4h-7a3 3 0 00-3 3v9h-4V6a6 6 0 016-6h10"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M59.691 3.5l1.5-3H52A5.5 5.5 0 0046.5 6v9.5h3V7A3.5 3.5 0 0153 3.5h6.691z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M27 0h9a6 6 0 016 6v10h-4V7a3 3 0 00-3-3h-9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M27.39.5l-.75 3H35A3.5 3.5 0 0138.5 7v8.5h3V6A5.5 5.5 0 0036 .5h-8.61z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M17 157h53v14H17z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M17.5 157.5h52v13h-52z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M77 154.346C77 160.23 62.002 165 43.5 165c-18.502 0-33.5-4.77-33.5-10.654V21.654C10 15.77 24.998 11 43.5 11 62.002 11 77 15.77 77 21.654v132.692z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M76.5 154.346V21.654c0-5.453-14.78-10.154-33-10.154s-33 4.7-33 10.154v132.692c0 5.453 14.78 10.154 33 10.154s33-4.7 33-10.154z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M36 62h17v30H36z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M36.5 62.5h16v29h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M5 137h9v5H5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M5.5 137.5h8v4h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M2 142h5v5H2z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M2.5 142.5h4v4h-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-fill",
    cx: 4.5,
    cy: 139.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-stroke",
    cx: 4.5,
    cy: 139.5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M2 132h5v1H2z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M2.5 132.5h4v1h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M4 133h1v3H4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M4.5 133.5h1v2h-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomHotWaterHeater);
export default __webpack_public_path__ + "static/media/RoomHotWaterHeater.de5b83122a2a16e2cb008341ec7b3593.svg";
export { ForwardRef as ReactComponent };